import React from 'react';
import {useDispatch, useSelector} from "react-redux";

import * as actionTypes from '../../../store/actions/actionTypes';

const AdmissionList_SubFilter_Item = ({value, label, handle}) => {
    const dispatch = useDispatch();
    const subfilters = useSelector(state => state.admissionList.subfilters);
    const admissions = useSelector(state => state.admissionList.admissions);

    const dispatchSet = (newValue) => dispatch({type: actionTypes.SUBFILTER_SET, subfilter: handle, value: newValue});
    const toggle = () => {
        if (hasSubfilter()) {
            dispatchSet(subfilters[handle].filter(_v => _v !== value));
        } else {
            if (subfilters[handle]) {
                dispatchSet([...subfilters[handle], value]);
            } else {
                dispatchSet([value]);
            }
        }
    }

    const hasSubfilter = () => (subfilters[handle] !== undefined) && (subfilters[handle].includes(value));
    const getMatchingCount = () => {
        if (handle !== 'DOCTOR') return 0;
        return admissions.filter(adm => adm.admittingDoctor === value).length;
    };
    const matchingCount = getMatchingCount();
    const btnClassName = () => {
        if (hasSubfilter()) return "btn-teal";
        // return matchingCount > 0 ? "btn-dark-gray" : "btn-light-gray";
        return "btn-dark-gray";
    };
    const displayLabel = (handle === 'DOCTOR' && matchingCount > 0) ? `${label} - ${matchingCount}` : label;

    return <li className="table-buttons-item"><a href="#" onClick={toggle} className={`btn btn-sm ${btnClassName()}`}>{displayLabel}</a></li>
}

export default AdmissionList_SubFilter_Item;